import { useQuery } from 'react-query';
import { StatisticsResponse } from './assessmentTypes';
import { getStatistics } from './assessmentService';

type Props<M> = {
    assessmentId: string;
    onError?: (error: Error) => void;
    onSuccess?: (data: StatisticsResponse) => void;
    mapper?: (data?: StatisticsResponse) => M | StatisticsResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: StatisticsResponse) => data;

export const useGetStatistics = <M = StatisticsResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    assessmentId,
}: Props<M>) => {
    const query = useQuery<StatisticsResponse, Error>(
        ['statistics', assessmentId],
        () => getStatistics(assessmentId),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
